module.exports = __webpack_public_path__ + "static/media/14UNEP9.adb8e12e.jpg";